import { memo, useMemo, useState } from 'react';
import ProfileBox from './profile-box';
import { ReactComponent as NotificationIcon } from 'assets/page-header/alert-grey.svg';
import Notifications from 'components/notifications';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { getNotifications } from 'store/features/notificationSlice';
import { useInterval } from 'hooks/useInterval';
// import GoogleTranslatorComponent from 'components/common/google-translator';
import TranslatorDropdown from './translator-dropdown';

const PageHeader = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useAppSelector(state => state.notifications);
  const { selectedOrganization } = useAppSelector(state => state.auth);
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setShowNotification(false);
    }
  };
  const fetchNotifications = async () => {
    try {
      await dispatch(getNotifications({ params: { type: 'notification' } })).catch(() => {});
    } catch (error) {}
  };
  useInterval(async () => {
    await fetchNotifications();
  }, 10000);
  const getProfileBoxUI = useMemo(() => {
    return (
      <div className="flex items-center justify-end">
        <ProfileBox />
      </div>
    );
  }, [selectedOrganization]);
  // const getGoogleTranslatorUI = useMemo(() => {
  //   return <GoogleTranslatorComponent />;
  // }, []);

  return (
    <div className="flex items-center px-[22px] h-[50px] min-h-[50px] w-full">
      <div className="flex items-center justify-end flex-1">
        <TranslatorDropdown />
        <div className="flex items-center justify-center relative" tabIndex={0} onBlur={onBlur}>
          <div
            className="relative flex items-center justify-center h-9 w-9 rounded-full border-1 border-divider2 bg-bg-50 cursor-pointer"
            onClick={() => setShowNotification(!showNotification)}
          >
            <NotificationIcon className="flex items-center justify-center" height={18} width={18} />
            {notifications?.length ? (
              <div className="absolute -top-0 -right-[2px] h-2 w-2 bg-red-500 rounded-full" />
            ) : (
              <></>
            )}
          </div>
          {showNotification && (
            <div className="flex absolute top-10">
              <Notifications
                notificationsList={notifications || []}
                handleHideNotification={() => setShowNotification(false)}
              />
            </div>
          )}
        </div>
      </div>
      {getProfileBoxUI}
    </div>
  );
};

export default memo(PageHeader);
